module.exports = __webpack_public_path__ + "static/Q1Answer5_Cooking_AaronThomas-a4c4a51d89ef0e724ee7911e16a47e4a.jpg";